var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-column-order",class:_vm.color,on:{"click":_vm.emitOrder}},[_c('div',{staticClass:"table-column-order__label",class:{
            'table-column-order__label--ordered': _vm.textActive
        }},[_vm._v(_vm._s(_vm.columnLabel))]),_c('div',{staticClass:"table-column-order__icon",class:{
            'table-column-order__icon--keep-visible': _vm.keepIcon,
            'table-column-order__icon--visible': _vm.orderDirection !== 0,
            'table-column-order__icon--vertical-flipped': _vm.orderDirection === 1,
        }},[_c('Icon',{attrs:{"iconClass":_vm.iconEnum.ArrowDown}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }